import { config } from '@rematter/config';
import { enumBookingStatus } from '@rematter/frontend-lib-api-client';
import { maybe } from '@rematter/ui-web';

import { bookingListQueryAtom } from '../_graphql/queryBookingList';
import {
  invoiceIdsByBookingAtom,
  invoicesAtom,
} from '../_graphql/queryInvoices';

import { atomFromQueryString } from '~/shared/state';

// 🟣🟣🟣 PARAMS
export const $searchParam = atomFromQueryString.string('q');

export const $limit = atomFromQueryString.number('limit', config.pageSize);
export const $offset = atomFromQueryString.number('offset', 0);

// 🟢🟢🟢 REMOTE DATA
export const $remoteBookings = bookingListQueryAtom((get) => {
  const searchParam = get($searchParam);

  return {
    variables: {
      searchTerm: searchParam,
      status: [enumBookingStatus.Open, enumBookingStatus.Completed],
      pagination: maybe(get($limit), (limit) => ({
        limit,
        offset: get($offset),
      })),
    },
  };
});

export const $invoiceIdsByBooking = invoiceIdsByBookingAtom(() => ({
  variables: {
    bookingIds: [],
  },
  lazy: true,
}));

export const $invoices = invoicesAtom(() => ({
  variables: {
    invoiceIds: [],
  },
  lazy: true,
}));
